export default class NewsImageSizes
{
    constructor(htvApi) {
        this.htvApi = htvApi;
    }

    List() {
        return this
            .htvApi
            .Call(this.htvApi.url + '/news-image-sizes');
    }

    Get(id) {
        return this.htvApi.Call(this.htvApi.url + '/news-image-sizes/' + id);
    }

    Create(newImageSize) {
        const requestData = {
            label: newImageSize.label,
            type: newImageSize.type,
            width: parseInt(newImageSize.width),
            height: parseInt(newImageSize.height),
        };

        return this.htvApi.Call(
            this.htvApi.url + '/news-image-sizes',
            {
                method: 'POST',
                body: JSON.stringify(requestData),
            }
        );
    }

    Delete(id) {
        return this.htvApi.Call(this.htvApi.url + '/news-image-sizes/' + id, {method: 'DELETE'});
    }
}
